export const UNIFIED_ONBOARDING_KEYS = {
  UNIFIED_ONBOARDING_DEFAULT_CATEGORIES: 'unifiedOnboardingDefaultCategories',
  UNIFIED_ONBOARDING_ALL_INDUSTRIES: 'unifiedOnboardingAllIndustries',
  UNIFIED_ONBOARDING_HAS_EXISTING_PRICEBOOK: 'unifiedOnboardingHasExistingPricebook',
};
